module.exports = __webpack_public_path__ + "static/Michael-McCalla-cycling-as-team-4f4cf5d1eb0f476a24c1b0e68256aa87.webp";